/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, ReactNode, useContext, useState } from 'react';
import DialogConfirm from './DialogConfirm';
import { DialogItemConfirm } from './types';

export const DialogContext = createContext<{
  dialogConfirm: DialogItemConfirm;
  setDialogConfirm: React.Dispatch<React.SetStateAction<DialogItemConfirm>>;
}>({
  dialogConfirm: {} as DialogItemConfirm,
  setDialogConfirm: () => {},
});

export const DialogsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [dialogConfirm, setDialogConfirm] = useState<DialogItemConfirm>(
    {} as DialogItemConfirm
  );

  return (
    <DialogContext.Provider value={{ dialogConfirm, setDialogConfirm }}>
      <DialogConfirm {...dialogConfirm} />
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogConfirm = () => {
  const { setDialogConfirm } = useContext(DialogContext);

  const onCloseDialogConfirm = () =>
    setDialogConfirm(prev => ({
      ...prev,
      open: false,
    }));

  return (
    options: Omit<DialogItemConfirm, 'onConfirmClick' | 'onCancelClick'>
  ): Promise<{
    isConfirmed: boolean;
    reason: 'confirm' | 'cancel' | 'native';
  }> =>
    new Promise(resolve => {
      setDialogConfirm({
        open: true,
        onClose: () => {
          resolve({ isConfirmed: false, reason: 'native' });
          onCloseDialogConfirm();
        },
        onCancelClick: () => {
          resolve({ isConfirmed: false, reason: 'cancel' });
          onCloseDialogConfirm();
        },
        onConfirmClick: () => {
          resolve({ isConfirmed: true, reason: 'confirm' });
          onCloseDialogConfirm();
        },
        ...options,
      });
    });
};
